var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _c("div", { staticClass: "wl-content-container" }, [
        _c("div", { staticClass: "wl-search-bar" }, [
          _c(
            "div",
            {
              class: [
                "search-collapse",
                _vm.showSearchParams ? "show-search-params" : "",
              ],
            },
            [
              _c(
                "div",
                {
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      _vm.showSearchParams = !_vm.showSearchParams
                    },
                  },
                },
                [
                  _vm.showSearchParams
                    ? [
                        _vm._v(_vm._s(_vm.$t("hide_search_conditions")) + " "),
                        _c("i", { staticClass: "el-icon-arrow-up" }),
                      ]
                    : [
                        _vm._v(_vm._s(_vm.$t("show_search_conditions"))),
                        _c("i", { staticClass: "el-icon-arrow-down" }),
                      ],
                ],
                2
              ),
              _vm.showSearchParams
                ? _c(
                    "div",
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "masterCode-sel-cls",
                          attrs: {
                            multiple: "",
                            filterable: "",
                            clearabled: "",
                            "collapse-tags": "",
                            "reserve-keyword": "",
                            remote: "",
                            "remote-method": _vm.masterCodeRemote,
                            placeholder: _vm.$t("SITE_CODE_PLACEHOLDER"),
                            loading: _vm.masterCodeLoading,
                          },
                          on: {
                            "visible-change": _vm.remoteVisibleChange,
                            "remove-tag": _vm.getStaffList,
                          },
                          model: {
                            value: _vm.masterCodeLists,
                            callback: function ($$v) {
                              _vm.masterCodeLists = $$v
                            },
                            expression: "masterCodeLists",
                          },
                        },
                        _vm._l(_vm.masterCodeOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label:
                                item.engagementMasterCode +
                                "[" +
                                item.siteName +
                                "]",
                              value: item.engagementMasterCode,
                            },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "wl-select input-with-select",
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t("table_header_label_code_type"),
                          },
                          model: {
                            value: _vm.codeType,
                            callback: function ($$v) {
                              _vm.codeType = $$v
                            },
                            expression: "codeType",
                          },
                        },
                        _vm._l(_vm.codeTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                      _c("el-input", {
                        staticClass: "input-with-select",
                        attrs: {
                          placeholder: _vm.$t("SITE_SEARCH_NAME_KEYWORD"),
                          maxlength: "100",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchContent,
                          callback: function ($$v) {
                            _vm.searchContent = $$v
                          },
                          expression: "searchContent",
                        },
                      }),
                      _c("el-input", {
                        staticClass: "input-with-select",
                        attrs: {
                          placeholder: _vm.$t("SITE_SEARCH_CLIENT_KEYWORD"),
                          maxlength: "100",
                          clearable: "",
                        },
                        model: {
                          value: _vm.clientName,
                          callback: function ($$v) {
                            _vm.clientName = $$v
                          },
                          expression: "clientName",
                        },
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select select-boolean",
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t("RolledForward"),
                          },
                          model: {
                            value: _vm.ifRollForward,
                            callback: function ($$v) {
                              _vm.ifRollForward = $$v
                            },
                            expression: "ifRollForward",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: false, label: "否" },
                          }),
                          _c("el-option", {
                            attrs: { value: true, label: "是" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select",
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: _vm.$t("SITE_OWNER_SHIP"),
                          },
                          model: {
                            value: _vm.ownerShip,
                            callback: function ($$v) {
                              _vm.ownerShip = $$v
                            },
                            expression: "ownerShip",
                          },
                        },
                        _vm._l(_vm.ownerShipOpt, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select select2",
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: _vm.$t("SITE_SERVICE_GROUP"),
                          },
                          model: {
                            value: _vm.serviceGroup,
                            callback: function ($$v) {
                              _vm.serviceGroup = $$v
                            },
                            expression: "serviceGroup",
                          },
                        },
                        _vm._l(_vm.serviceGroupOpt, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select select-boolean",
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t("SITE_TABLE_HEADER_IS_LLP"),
                          },
                          model: {
                            value: _vm.siteFlag,
                            callback: function ($$v) {
                              _vm.siteFlag = $$v
                            },
                            expression: "siteFlag",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: "0", label: "否" },
                          }),
                          _c("el-option", {
                            attrs: { value: "1", label: "是" },
                          }),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticClass: "input-with-select",
                        attrs: {
                          placeholder: _vm.$t("client_user_email_keyword"),
                          maxlength: "100",
                          clearable: "",
                        },
                        model: {
                          value: _vm.clientUser,
                          callback: function ($$v) {
                            _vm.clientUser = $$v
                          },
                          expression: "clientUser",
                        },
                      }),
                      _c("input-number-range", {
                        staticClass: "input-with-select",
                        attrs: {
                          value: _vm.subEntitiesCountList,
                          fromPlaceholder: _vm.$t("SITE_SEARCH_ENTITY"),
                          toPlaceholder: _vm.$t("SITE_SEARCH_ENTITY"),
                        },
                        on: {
                          changeFrom: _vm.changeFrom,
                          changeTo: _vm.changeTo,
                        },
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select",
                          attrs: {
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            clearable: "",
                            placeholder: _vm.$t("SITE_TABLE_HEADER_SITE_ADMIN"),
                            "remote-method": _vm.queryUserNameSearch,
                            loading: _vm.userLoading,
                          },
                          model: {
                            value: _vm.userNameVal,
                            callback: function ($$v) {
                              _vm.userNameVal = $$v
                            },
                            expression: "userNameVal",
                          },
                        },
                        _vm._l(_vm.userOpt, function (item) {
                          return _c("el-option", {
                            key: item.email,
                            attrs: {
                              label:
                                item.userName + "(" + item.profitCenter + ")",
                              value: item.email,
                            },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select",
                          attrs: {
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            clearable: "",
                            placeholder: _vm.$t("PAGE_KPMG_TEAM_TITLE"),
                            "remote-method": _vm.queryMemberSearch,
                            loading: _vm.memberLoading,
                          },
                          model: {
                            value: _vm.memberVal,
                            callback: function ($$v) {
                              _vm.memberVal = $$v
                            },
                            expression: "memberVal",
                          },
                        },
                        _vm._l(_vm.memberOpt, function (item) {
                          return _c("el-option", {
                            key: item.email,
                            attrs: {
                              label:
                                item.userName + "(" + item.profitCenter + ")",
                              value: item.email,
                            },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select",
                          attrs: {
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            clearable: "",
                            placeholder: _vm.$t("SITE_LABEL_SITE_OWNER"),
                            "remote-method": _vm.querySiteOwnerSearch,
                            loading: _vm.siteOwnerLoading,
                          },
                          model: {
                            value: _vm.siteOwnerVal,
                            callback: function ($$v) {
                              _vm.siteOwnerVal = $$v
                            },
                            expression: "siteOwnerVal",
                          },
                        },
                        _vm._l(_vm.siteOwnerOpt, function (item) {
                          return _c("el-option", {
                            key: item.email,
                            attrs: {
                              label:
                                item.userName + "(" + item.profitCenter + ")",
                              value: item.email,
                            },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "input-with-select",
                          attrs: {
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            clearable: "",
                            placeholder: _vm.$t("SITE_LABEL_SITE_MANGER"),
                            "remote-method": _vm.querySiteManagerSearch,
                            loading: _vm.siteManagerLoading,
                          },
                          model: {
                            value: _vm.siteManagerVal,
                            callback: function ($$v) {
                              _vm.siteManagerVal = $$v
                            },
                            expression: "siteManagerVal",
                          },
                        },
                        _vm._l(_vm.siteManagerOpt, function (item) {
                          return _c("el-option", {
                            key: item.email,
                            attrs: {
                              label:
                                item.userName + "(" + item.profitCenter + ")",
                              value: item.email,
                            },
                          })
                        }),
                        1
                      ),
                      _c("el-date-picker", {
                        staticClass: "input-with-select date-range",
                        attrs: {
                          type: "daterange",
                          clearable: "",
                          "range-separator": _vm.$t("SITE_TO"),
                          "value-format": "yyyy-MM-dd",
                          "start-placeholder": _vm.$t("SITE_CLOSE_DATE"),
                          "end-placeholder": _vm.$t("SITE_CLOSE_DATE"),
                        },
                        model: {
                          value: _vm.closeDateRange,
                          callback: function ($$v) {
                            _vm.closeDateRange = $$v
                          },
                          expression: "closeDateRange",
                        },
                      }),
                      _c("el-date-picker", {
                        staticClass: "input-with-select date-range",
                        attrs: {
                          type: "daterange",
                          clearable: "",
                          "range-separator": _vm.$t("SITE_TO"),
                          "value-format": "yyyy-MM-dd",
                          "start-placeholder": _vm.$t("create_date"),
                          "end-placeholder": _vm.$t("create_date"),
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "wl-green",
                          attrs: { icon: "el-icon-search" },
                          on: { click: _vm.searchSite },
                        },
                        [_vm._v(_vm._s(_vm.$t("btn_search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "cancel-btn",
                          on: { click: _vm.resetTable },
                        },
                        [_vm._v(_vm._s(_vm.$t("COMMON_CLEAR_BTN")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticClass: "wl-right" },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { icon: "el-icon-plus" },
                  on: { click: _vm.onAddAccount },
                },
                [_vm._v(_vm._s(_vm.$t("COMMON_ADD")) + " ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green svg-btn",
                  on: { click: _vm.downloadSites },
                },
                [
                  _c("img", {
                    staticClass: "btn-icon",
                    attrs: {
                      src: require("@/assets/img/icon-export.svg"),
                      width: "100%",
                    },
                  }),
                  _vm._v(
                    _vm._s(_vm.$t("SITE_DOWNLOAD_SITE")) + "\n                "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { icon: "el-icon-download" },
                  on: { click: _vm.download },
                },
                [_vm._v(_vm._s(_vm.$t("COMMON_DOWNLOAD_TEMP")) + " ")]
              ),
              _c(
                "el-upload",
                {
                  staticClass: "template-uploader",
                  attrs: {
                    action: "url",
                    "http-request": _vm.uploadFiles,
                    "show-file-list": false,
                    "on-success": _vm.handleAvatarSuccess,
                    "before-upload": _vm.beforeAvatarUpload,
                  },
                },
                [
                  _c("el-button", { staticClass: "wl-green svg-btn" }, [
                    _c("img", {
                      staticClass: "btn-icon",
                      attrs: {
                        src: require("@/assets/img/icon-import.svg"),
                        width: "100%",
                      },
                    }),
                    _vm._v(_vm._s(_vm.$t("COMMON_IMPORT"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "table-out-wrap" },
          [
            _c(
              "div",
              {
                class: [
                  "table-container-wrapper site-table-wrap",
                  _vm.showSearchParams ? "show-table-bottom-operate" : "",
                ],
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "wl-user-table",
                    attrs: {
                      height: "100%",
                      data: _vm.data,
                      border: "",
                      stripe: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "index", width: "70" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "engagementMasterCode",
                        width: "110",
                        label: _vm.$t("SITE_TABLE_HEADER_ENGAGEMENT_CODE"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "180",
                        label: _vm.$t("table_header_label_code_type"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.codeTypeOptions.find(
                                      (v) => v.value == scope.row.codeType
                                    )
                                      ? _vm.codeTypeOptions.find(
                                          (v) => v.value == scope.row.codeType
                                        ).label
                                      : ""
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "siteName",
                        "show-overflow-tooltip": "",
                        width: "160",
                        label: _vm.$t("SITE_TABLE_HEADER_SITE_NAME"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "clientName",
                        width: "130",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("FORM_LABEL_clientName"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "130",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("RolledForward"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    scope.row.ifRollForward
                                      ? _vm.$t("COMMON_YES")
                                      : _vm.$t("COMMON_NO")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "codeCloseDatetime",
                        width: "160",
                        label: _vm.$t("SITE_CLOSE_DATE"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "ownerShip",
                        width: "170",
                        label: _vm.$t("SITE_OWNER_SHIP"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "serviceGroup",
                        width: "200",
                        label: _vm.$t("SITE_SERVICE_GROUP"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "130",
                        label: _vm.$t("SITE_TABLE_HEADER_IS_LLP"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    scope.row.siteFlag === "1"
                                      ? _vm.$t("COMMON_YES")
                                      : _vm.$t("COMMON_NO")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "subEntitiesCount",
                        width: "150",
                        label: _vm.$t("SITE_TABLE_HEADER_NUMBER_OF_ENTITIES"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "userNameList",
                        "min-width": "150",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("SITE_TABLE_HEADER_SITE_ADMIN"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "180",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("PAGE_KPMG_TEAM_TITLE"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    scope.row.memberList
                                      .map(
                                        (member) =>
                                          member.userName +
                                          "(" +
                                          member.profitCenter +
                                          ")"
                                      )
                                      .join("; ")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "180",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("SITE_LABEL_SITE_OWNER"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    scope.row.siteOwner.id &&
                                      scope.row.siteOwner.id !== ""
                                      ? scope.row.siteOwner.userName +
                                          "(" +
                                          scope.row.siteOwner.profitCenter +
                                          ")"
                                      : ""
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "180",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("SITE_LABEL_SITE_MANGER"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    scope.row.siteManager.id &&
                                      scope.row.siteManager.id !== ""
                                      ? scope.row.siteManager.userName +
                                          "(" +
                                          scope.row.siteManager.profitCenter +
                                          ")"
                                      : ""
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "180",
                        "show-overflow-tooltip": "",
                        label: _vm.$t("TABLE_HEADER_CLIENTUSER"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    scope.row.clientUserList
                                      .map((member) => member.userAccount)
                                      .join("; ")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createBy",
                        "show-overflow-tooltip": "",
                        width: "200",
                        label: _vm.$t("SITE_TABLE_HEADER_CREATE_BY"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createDate",
                        width: "160",
                        label: _vm.$t("SITE_TABLE_HEADER_CREATE_TIME"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "updateBy",
                        "show-overflow-tooltip": "",
                        width: "200",
                        label: _vm.$t("SITE_TABLE_HEADER_MODIFIED_BY"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "action",
                        width: "120",
                        align: "center",
                        fixed: "right",
                        label: _vm.$t("TABLE_HEADER_Action"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("i", {
                                staticClass:
                                  "el-icon-edit-outline wl-icon-edit",
                                attrs: { "aria-hidden": "true" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onEditAccount(scope.row)
                                  },
                                },
                              }),
                              _c("i", {
                                staticClass: "el-icon-delete wl-icon-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.onDeleteAccount(scope.row)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-pagination", {
              staticClass: "wl-pagination",
              attrs: {
                "current-page": _vm.pagination.pageNum,
                "page-size": _vm.pagination.pageSize,
                "page-sizes": [10, 50, 100],
                layout: "prev, pager, next,sizes,total",
                total: _vm.pagination.total,
              },
              on: {
                "current-change": _vm.onCurrentPageChange,
                "size-change": _vm.onSizeChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm.addVisible
        ? _c("site-add", {
            attrs: {
              onCancel: _vm.toggleAddVisible,
              defaultValue: _vm.currentRow,
              editLoading: _vm.editLoading,
              onAddOrEdit: _vm.addOrEditSite,
            },
          })
        : _vm._e(),
      _vm.deleteVisible
        ? _c("site-delete", {
            attrs: {
              data: _vm.currentRow,
              onCancel: _vm.toggleDeleteVisible,
              onDelete: _vm.deleteSite,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }